import { queryOptions, useQuery } from "@tanstack/react-query";

import { fetchMe } from "./auth-api";

export const authQueryOptions = queryOptions({
  queryKey: ["auth", "me"] as const,
  queryFn: fetchMe,
  staleTime: Infinity,
  gcTime: Infinity,
  retry: 1,
  retryDelay: 1000,
  /*
   * **"always" を外さないこと。** 既定の networkMode("online") では、fetch が
   * ネットワークレベルで失敗する環境（API が IP 制限で落とされる・オフライン）で
   * react-query がクエリを **pause 扱いにして promise を解決しない**ことがある。
   * その場合 `ensureQueryData` を await しているルートの beforeLoad が永遠に終わらず、
   * 公開ランディングも保護ルートも**真っ白のまま**になる（dev 環境で実際に発生。
   * /auth/me への試行 1〜2 回のあと、リトライも reject も起きないことを実測で確認）。
   * 認証プローブは「答えが出ない」より「失敗が返る」ほうが常に良い。
   */
  networkMode: "always",
});

export function useAuth() {
  const { data } = useQuery(authQueryOptions);
  return { user: data ?? null };
}
